export default [
  {
    path: '/security/settings',
    name: 'security-settings',
    component: () => import('@/views/security/SecuritySettings.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
      pageTitle: 'Security Settings',
      breadcrumb: [
        { text: 'Security Settings', active: true },
      ],
    },
  },
]
